import * as types from './Help.types';

const initialState = null;

const help = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_HELP_LIST_SUCCESS:
      return Object.assign({}, state, action.help);

    default:
      return state;
  }
};

export default help;
